function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC } from 'react';
import { Image, IImageProps } from '../Image';
import logoPayFillGreen from './LogoSber.assets/logoPayFillGreen.svg';
import logoPayOutlineGreen from './LogoSber.assets/logoPayOutlineGreen.svg';
import logoPayOutlineBlack from './LogoSber.assets/logoPayOutlineBlack.svg';
import logoPayFillBlack from './LogoSber.assets/logoPayFillBlack.svg';
import logoPayFillGradient from './LogoSber.assets/logoPayFillGradient.svg';
import logoPayOutlineBlackRect from './LogoSber.assets/logoPayOutlineBlackRect.svg';
import logoPayOutlineGreenRect from './LogoSber.assets/logoPayOutlineGreenRect.svg';
import logoPayOutlineWhite from './LogoSber.assets/logoPayOutlineWhite.svg';
import logoPayFillWhite from './LogoSber.assets/logoPayFillWhite.svg';
import logoPayFillBlackRect from './LogoSber.assets/logoPayFillBlackRect.svg';
import logoPayFillGradientRect from './LogoSber.assets/logoPayFillGradientRect.svg';
import logoPayFillGreenRect from './LogoSber.assets/logoPayFillGreenRect.svg';
import logoPayFillWhiteRect from './LogoSber.assets/logoPayFillWhiteRect.svg';
const LogoPayRoundedSberKinds = {
  fillBlack: logoPayFillBlack,
  fillGradient: logoPayFillGradient,
  fillGreen: logoPayFillGreen,
  fillWhite: logoPayFillWhite,
  outlineBlack: logoPayOutlineBlack,
  outlineGreen: logoPayOutlineGreen,
  outlineWhite: logoPayOutlineWhite
};
const LogoPayRectangularSberKinds = {
  fillBlack: logoPayFillBlackRect,
  fillGradient: logoPayFillGradientRect,
  fillGreen: logoPayFillGreenRect,
  fillWhite: logoPayFillWhiteRect,
  outlineBlack: logoPayOutlineBlackRect,
  outlineGreen: logoPayOutlineGreenRect,
  outlineWhite: logoPayOutlineWhite
};
export const LogoPay = ({
  alt = 'Логотип Сбер Оплата',
  kind = 'fillGreen',
  size = 96,
  ...props
}) => {
  const srcProp = Number(size) === 24 ? LogoPayRectangularSberKinds[kind] : LogoPayRoundedSberKinds[kind];
  if (!srcProp) return null;
  return /*#__PURE__*/React.createElement(Image, _extends({}, props, {
    alt: alt,
    width: size,
    height: "auto",
    src: srcProp
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LogoPay.displayName = 'LogoPay';
}